import { render, staticRenderFns } from "./richeng_upolad.vue?vue&type=template&id=4adcb987&scoped=true&"
import script from "./richeng_upolad.vue?vue&type=script&lang=js&"
export * from "./richeng_upolad.vue?vue&type=script&lang=js&"
import style0 from "./richeng_upolad.vue?vue&type=style&index=0&id=4adcb987&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adcb987",
  null
  
)

export default component.exports